module.exports = __webpack_public_path__ + "media/images/illustrations/versus-7d9fcf7aa609d1e91dcd0cc83ba805bb.svg";